import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import { InputLabel, Select, MenuItem, TextField, Fade, Avatar } from '@material-ui/core';
import ProfissionalService from '../../services/ProfissionalService';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { format, parse } from 'date-fns';
import MUIDataTable from 'mui-datatables';
import Edit from '@material-ui/icons/Edit';
import TrashIcon from '@material-ui/icons/Delete';
import LongMenu from '../share/LongMenu';
import ToolbarNovo from './ToolbarNovo';
import FormDialogProfissional from './FormDialogProfissional';
import AlertDialogSlide from '../share/AlertDialogSlide';
import VariantSnackbar from '../share/VariantSnackbar';
import DialogErrosValidacao from '../share/DialogErrosValidacao';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    width: 600,
  },
  button: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginLeft: theme.spacing.unit,
  },
  buttonTrash: {
    marginTop: theme.spacing.unit,
  },
  input: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    // cursor: 'pointer',
  },
  centralizado: {
    textAlign: 'center'
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  tableRowCredenciado: {
    backgroundColor: 'rgb(223, 240, 216)',
  },
  formControlAutoCompletePrestador: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
  formControlAutoCompleteProfissional: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
  formControlAutoCompleteCRO: {
    margin: theme.spacing.unit,
    minWidth: 100,
  },
  selectEspecialidade: {
    marginLeft: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    width: 480,
  },
  selectUF: {
    marginLeft: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 3,
    width: 250,
  },
  textFieldData: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});
@inject('aplicacaoStore')
@observer
class ProfissionalCadastro extends React.Component {
  profissionalService = new ProfissionalService();
  state = {
    prestadores: [],
    profissionaisNomes: [],
    especialidades: [],
    CROs: [],
    UFs: [],
    profissionais: [],
    profissionalPrestadores: [],
    seqEspecialidadeSelected: 0,
    seqPrestadorSelected: 0,
    seqProfissionalSelected: 0,
    seqCROSelected: 0,
    seqUFSelected: 0,
    dataVigencia: '', // format(new Date(0), 'YYYY-MM-DD'),
    fetchingInicio: true,
    fetching: false,
    buscarDisabled: false,
    anchorEl: null,
    openDialog: false,
    tituloFormDialog: '',
    profissionalSelecionado: {},
    modoInclusao: false,
    isEditavel: false,
    openDialogExclusao: false,
    dialogTitleExclusao: 'Exclusão de Profissional',
    dialogMessage: 'Deseja excluir este profissional?',
    openDialogValidacao: false,
    dialogTitle: '',
    dialogContent: '',
    snackOpen: false,
    snackMessage: '',
    sucesso: false
  }

  componentDidMount = async () => {
    await Promise.all([this.consultarPrestadoresEProfissionais(), this.consultarCROs(), this.consultarEspecialidades(), this.consultarUfs()]);
    this.setState({fetchingInicio: false});
  }

  consultarPrestadoresEProfissionais = async () => {
    let prestadores = await this.props.aplicacaoStore.getPrestadores();
    let profissionaisNomes = await this.props.aplicacaoStore.getProfissionais();
    this.setState({ prestadores: prestadores, profissionaisNomes: profissionaisNomes });
  }

  consultarEspecialidades = async () => {
    let especialidades = await this.props.aplicacaoStore.getEspecialidades();
    this.setState({ especialidades: especialidades });
  }

  consultarCROs = async () => {
    let CROs = await this.props.aplicacaoStore.getCROs();
    this.setState({ CROs: CROs });
  }

  consultarUfs = async () => {
    let UFs = await this.props.aplicacaoStore.getUfs();
    this.setState({ UFs: UFs });
  }

  handleDialogClose = async () => {
    this.setState({openDialog: false});
    event.preventDefault();
    const filter = {
      seqPrestador: this.state.seqPrestadorSelected,
      seqProfissional: this.state.seqProfissionalSelected,
      seqCRO: this.state.seqCROSelected,
      seqEspecialidade: this.state.seqEspecialidadeSelected,
      seqUF: this.state.seqUFSelected === 0 ? 'TODAS' : this.state.seqUFSelected,
      dataVigencia: this.state.dataVigencia === '' ? parse(format(new Date(0), 'YYYY-MM-DD')) : parse(this.state.dataVigencia)
    };
    if (this.state.profissionais.length !== 0) {
      await this.consultarProfissionais(filter);
    }
  };
  handleCloseDialogExclusao = () => {
    this.setState({ openDialogExclusao: false });
  };
  handleDialogConfirmExclusao = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirProfissional();
  }

  getSuggestionValuePrestador = (suggestion, id) => {
    this.setState({
      seqPrestadorSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }

  getSuggestionValueProfissional = (suggestion, id) => {
    this.setState({
      seqProfissionalSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  getSuggestionValueCRO = (suggestion, id) => {
    this.setState({
      // seqCROSelected: id !== undefined ? suggestion.nome : suggestion.nome,
      seqCROSelected: suggestion.nome === undefined ? suggestion : suggestion.nome,
    });
    return suggestion.nome;
  }
  handleChangeSelectEspecialidade = event => {
    this.setState({ seqEspecialidadeSelected: event.target.value });
  };
  handleChangeSelectUF = event => {
    this.setState({ seqUFSelected: event.target.value });
  };
  handleChangeDataVigencia = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleClickBuscar = async (event) => {
    event.preventDefault();
    const filter = {
      seqPrestador: this.state.seqPrestadorSelected,
      seqProfissional: this.state.seqProfissionalSelected,
      seqCRO: this.state.seqCROSelected === undefined || this.state.seqCROSelected === '' ? 0 : this.state.seqCROSelected,
      seqEspecialidade: this.state.seqEspecialidadeSelected,
      seqUF: this.state.seqUFSelected === 0 ? 'TODAS' : this.state.seqUFSelected,
      dataVigencia: this.state.dataVigencia === '' ? parse(format(new Date(0), 'YYYY-MM-DD')) : parse(this.state.dataVigencia)
    };
    await this.consultarProfissionais(filter);
  }
  consultarProfissionais = async (filter) => {
    this.setState({fetching: true});
    const profissionais = await this.profissionalService.consultarProfissionais(filter);
    this.setState({fetching: false, profissionais: profissionais});
  }
  handleClickMenu = (event, tableMeta) => {
    const brancoAcoes = '';
    let profissionalPrestadores = [];
    let profPrestadoresAux = this.state.profissionais[tableMeta.rowIndex][7];
    profPrestadoresAux.map(res => {
      const { seqRegistroPrestador, seqPrestador, nomePrestador, dtaInicio, dtaFim, desEspecialidades } = res;
      profissionalPrestadores.push(Object.values({ seqRegistroPrestador, seqPrestador, nomePrestador, dtaInicio, dtaFim, desEspecialidades, brancoAcoes }));
    });

    const profissionalSelecionado = {
      seqProfissional: this.state.profissionais[tableMeta.rowIndex][0],
      nome: this.state.profissionais[tableMeta.rowIndex][1],
      numRegistro: this.state.profissionais[tableMeta.rowIndex][2],
      codConselho: this.state.profissionais[tableMeta.rowIndex][3],
      seqUF: this.state.profissionais[tableMeta.rowIndex][4] === undefined ||
      this.state.profissionais[tableMeta.rowIndex][4] === null ? 0 : this.state.profissionais[tableMeta.rowIndex][4],
      profissionalPrestador: profissionalPrestadores,
    };
    this.setState({ anchorEl: event.currentTarget, profissionalSelecionado: profissionalSelecionado, profissionalPrestadores: profissionalPrestadores });
  }
  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }
  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialog: true, tituloFormDialog: 'Alteração de Profissional - ' + this.state.profissionalSelecionado.nome, modoInclusao: false, isEditavel: true});
    }
    if (index === 1) {
      this.handleClickOpenDialogExclusao();
    }
  }
  handleClickOpenDialogExclusao = () => {
    this.setState({ openDialogExclusao: true });
  };

  handleClickIncluir = () => {
    this.setState({openDialog: true, tituloFormDialog: 'Inclusão de Profissional', profissionalSelecionado: {}, profissionalPrestadores: [], modoInclusao: true, isEditavel: true});
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };
  incluirProfissional = async (profissional) => {
    this.setState({fetching: true, profissionalSelecionado: {}});
    let result = await this.profissionalService.validarProfissional(profissional, 'S');
    if (result.data === '') {
      result = await this.profissionalService.incluirProfissional(profissional);
      await this.onOperacaoFinalizadaDialog(result);
    } else {
      this.setState({fetching: false, snackOpen: true, snackMessage: 'Operação não realizada. ' + result.data, sucesso: false});
    }
  }
  alterarProfissional = async (profissional) => {
    this.setState({fetching: true, profissionalSelecionado: {}});
    // let result = await this.profissionalService.validarProfissional(profissional, 'N');
    // if (result.data === '') {
    let result = await this.profissionalService.alterarProfissional(profissional);
    await this.onOperacaoFinalizadaDialog(result);
    // } else {
    //   this.setState({fetching: false, snackOpen: true, snackMessage: 'Operação não realizada. ' + result.data, sucesso: false});
    // }
  }
  excluirProfissional = async () => {
    const result = await this.profissionalService.excluirProfissional(this.state.profissionalSelecionado.seqProfissional);
    this.onOperacaoFinalizadaDialog(result);
  }
  onOperacaoFinalizadaDialog = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        openDialog: false,
        sucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          sucesso: true,
          fetching: false,
          openDialog: false });
        event.preventDefault();
        const filter = {
          seqPrestador: this.state.seqPrestadorSelected,
          seqProfissional: this.state.seqProfissionalSelected,
          seqCRO: this.state.seqCROSelected,
          seqEspecialidade: this.state.seqEspecialidadeSelected,
          seqUF: this.state.seqUFSelected === 0 ? 'TODAS' : this.state.seqUFSelected,
          dataVigencia: this.state.dataVigencia === '' ? parse(format(new Date(0), 'YYYY-MM-DD')) : parse(this.state.dataVigencia)
        };
        await this.consultarProfissionais(filter);
      } else {
        this.setState({
          openDialogValidacao: true,
          openDialog: false,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }
  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };

  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 5,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>profissional(is) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome Profissional',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Número Registro',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Conselho',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'UF',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Prestadores/Especialidades',
        options: {
          filter: true,
          filterType: 'multiselect',
          customBodyRender: (value) => {
            return value.length === 0 ? <Typography>Profissional sem prestador vinculado</Typography>
              : value.map((val, key) => {
                return <Typography style={{display: 'block'}} key={key}>{val}</Typography>;
              });
          }
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <Edit />,
                primaryText: 'Editar Profissional...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <TrashIcon />,
                primaryText: 'Excluir Profissional...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
      {
        name: 'profissionalPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const { classes } = this.props;
    const { prestadores,
      profissionaisNomes,
      especialidades,
      seqEspecialidadeSelected,
      seqUFSelected,
      CROs,
      UFs,
      dataVigencia,
      fetchingInicio,
      fetching,
      profissionais } = this.state;
    return (
      <React.Fragment>
        <Link to='/odontologico' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Profissionais Odontológicos</Typography>
              <Avatar className={classes.avatar}>{profissionais.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio ? <LinearProgressBlockScreen />
          : <Paper className={classes.body} elevation={0}>
            <FormControl className={classes.formControlAutoCompletePrestador}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValuePrestador}
                suggestions={prestadores}
                maxSuggestions={6}
                placeholder={'Digite o nome do prestador...'} />
            </FormControl>
            <FormControl className={classes.formControlAutoCompleteProfissional}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValueProfissional}
                suggestions={profissionaisNomes}
                maxSuggestions={6}
                placeholder={'Digite o nome do profissional...'} />
            </FormControl>
            <FormControl className={classes.formControlAutoCompleteCRO}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValueCRO}
                suggestions={CROs}
                maxSuggestions={10}
                placeholder={'Digite o CRO...'} />
            </FormControl>
            <FormControl>
              <Button
                variant='extendedFab'
                title='Consultar'
                disabled={this.state.buscarDisabled}
                type='submit'
                onTouchStart={this.handleClickBuscar}
                onClick={this.handleClickBuscar}
                className={classes.button}>
                <Search className={classes.searchIcon} />
                Buscar
              </Button>
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectEspecialidade}>
                Especialidades
              </InputLabel>
              <Select
                className={classes.selectEspecialidade}
                value={seqEspecialidadeSelected}
                onChange={this.handleChangeSelectEspecialidade}
                inputProps={{
                  name: 'seqEspecialidadeSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODAS</MenuItem>
                {especialidades.map((especialidade, idx) => {
                  return (<MenuItem key={idx} value={especialidade.id}>{especialidade.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectUF}>
                UF
              </InputLabel>
              <Select
                className={classes.selectUF}
                value={seqUFSelected}
                onChange={this.handleChangeSelectUF}
                inputProps={{
                  name: 'seqUFSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODAS</MenuItem>
                {UFs.map((Uf, idx) => {
                  return (<MenuItem key={idx} value={Uf.id}>{Uf.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <TextField
                id='date'
                label='Data de Vigência'
                type='date'
                value={dataVigencia}
                onChange={this.handleChangeDataVigencia}
                inputProps={{
                  name: 'dataVigencia',
                }}
                className={classes.textFieldData}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Paper>
        }
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={profissionais}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        {this.state.openDialog &&
          <FormDialogProfissional
            titulo={this.state.tituloFormDialog}
            profissional={this.state.profissionalSelecionado}
            profissionalPrestadores={this.state.profissionalPrestadores ? this.state.profissionalPrestadores : []}
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            handleClose={this.handleDialogClose}
            handleSave={this.state.modoInclusao ? this.incluirProfissional : this.alterarProfissional}
            UFs={UFs}
            prestadores={prestadores}
            especialidades={especialidades}
            isEditavel={this.state.isEditavel} />}
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExclusao}
          handleClick={this.handleDialogConfirmExclusao}
          title={this.state.dialogTitleExclusao}
          message={this.state.dialogMessage} />
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogValidacao &&
          <DialogErrosValidacao
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
          />}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ProfissionalCadastro);
